import { Components, Theme } from '@mui/material/styles'

export const MuiModal: Components<Theme>['MuiModal'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.basicMenu': {
        '.MuiMenu-list': {
          background: theme.palette.common.white,
          borderRadius: '4px',
          padding: 0,
          minWidth: '200px',
          maxHeight: 'initial',
        },
        '.MuiPaper-root': {
          background: theme.palette.common.white,
          borderRadius: '8px',
          margin: 0,
        },
      },
      '&.MuiTelInput-Menu': {
        '.MuiMenu-paper': {
          width: '100%',
        },
      },
      '.MuiPickersLayout-root': {
        '.MuiDialogActions-root': {
          '.MuiButtonBase-root': {
            color: theme.palette.primary.main,
          },
        },
      },
    }),
  },
}
